/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Dispatch, ReactElement, SetStateAction, useState } from 'react'

import { CloseOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  PageHeader,
  Result,
  Row,
  Typography,
} from 'antd'
import ID_COMPONENTE from 'config/idComponente'
import { IArmazem } from 'Models/docas'
import moment from 'moment'
import WsDocasService from 'Services/WS_DOCAS'

interface IProps {
  armazemSelecionado?: IArmazem
  dataSelecionada: moment.Moment
  setDataSelecionada: Dispatch<SetStateAction<moment.Moment>>
  setTela: Dispatch<SetStateAction<string>>
}

const LiberacaoAgenda = ({
  armazemSelecionado,
  dataSelecionada,
  setDataSelecionada,
  setTela,
}: IProps): ReactElement => {
  const [result, setResult] = useState<number>(0)
  const [resultError, setResultError] = useState<string>('')
  const [liberandoAgenda, setLiberandoAgenda] = useState<boolean>(false)
  const { Paragraph } = Typography

  const disabledDates = (current: moment.Moment) => {
    const inPast = moment().diff(current, 'days') > 0
    const tooEarly = current.diff(moment().add(10, 'days'), 'days') >= 0
    return inPast || tooEarly
  }

  const handleChangeData = (date: any) => {
    setDataSelecionada(date)
  }

  const handleSubmitLiberarAgenda = async () => {
    if (armazemSelecionado?.cdAgendamentoDocasArmazem && dataSelecionada) {
      setLiberandoAgenda(true)

      const { data } = await WsDocasService.agenda.liberarAgenda(
        ID_COMPONENTE.DOCAS,
        armazemSelecionado?.cdAgendamentoDocasArmazem,
        dataSelecionada.format('YYYY-MM-DD'),
      )

      if (data.statusCode === 501) {
        setResult(200)
      } else {
        setResult(400)
        if (data.message) {
          setResultError(data.message)
        }
      }

      setLiberandoAgenda(false)
    }
  }

  return (
    <>
      <PageHeader
        ghost={false}
        title="Liberar Agenda"
        subTitle={armazemSelecionado?.nomeArmazem}
        extra={[
          <Button key="1" type="text" onClick={() => setTela('')}>
            <CloseOutlined />
          </Button>,
        ]}
      />
      {result === 0 ? (
        <Form
          layout="vertical"
          initialValues={{
            data: dataSelecionada,
            armazem: armazemSelecionado?.cdAgendamentoDocasArmazem,
          }}
        >
          <Row>
            <Paragraph>
              A liberação de agendas cria a estrutura definida na configuração
              de Armazém para que as transportadoras possam ver as Docas,
              Janelas e Horários disponibilizados de cada Armazém.
            </Paragraph>
          </Row>
          <Row align="middle">
            <Col>
              <Form.Item name="data" label="Data:">
                <DatePicker
                  allowClear={false}
                  size="middle"
                  disabledDate={disabledDates}
                  format="DD/MM/YYYY"
                  id="docas-input-data"
                  onChange={handleChangeData}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row align="middle">
            <Col>
              <Button
                type="primary"
                onClick={() => handleSubmitLiberarAgenda()}
                loading={liberandoAgenda}
              >
                Liberar agenda
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <>
          {result === 200 ? (
            <Result
              status="success"
              title="Agenda liberada com sucesso!"
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => setResult(0)}
                >
                  Liberar outra data
                </Button>,
              ]}
            />
          ) : null}

          {result !== 200 ? (
            <Result
              status="error"
              title={resultError}
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => setResult(0)}
                >
                  Tentar novamente
                </Button>,
              ]}
            />
          ) : null}
        </>
      )}
    </>
  )
}

export default LiberacaoAgenda
